module.exports = __webpack_public_path__ + "img/socupdef.df2a8a9d.svg";